import { motion } from "framer-motion";
import { Shield, CreditCard, Lock, Award, Globe, CheckCircle } from "lucide-react";

const badges = [
  {
    icon: CreditCard,
    label: "Paiement sécurisé",
    sublabel: "Stripe™",
    color: "text-[hsl(250,80%,65%)]",
    bgColor: "bg-[hsl(250,80%,65%)]/10",
  },
  {
    icon: Lock,
    label: "Chiffrement SSL",
    sublabel: "256 bits",
    color: "text-primary",
    bgColor: "bg-primary/10",
  },
  {
    icon: Shield,
    label: "Conforme RGPD",
    sublabel: "Europe",
    color: "text-[hsl(210,80%,55%)]",
    bgColor: "bg-[hsl(210,80%,55%)]/10",
  },
  {
    icon: Award,
    label: "Satisfait ou remboursé",
    sublabel: "14 jours",
    color: "text-accent",
    bgColor: "bg-accent/10",
  },
  {
    icon: Globe,
    label: "Hébergement premium",
    sublabel: "99.9% uptime",
    color: "text-primary",
    bgColor: "bg-primary/10",
  },
  {
    icon: CheckCircle,
    label: "Avis vérifiés",
    sublabel: "4.9/5 ★",
    color: "text-[hsl(142,70%,45%)]",
    bgColor: "bg-[hsl(142,70%,45%)]/10",
  },
];

const SellTrustStrip = () => (
  <section className="py-10 border-y border-border/20">
    <div className="container mx-auto px-6">
      <motion.p
        className="text-center text-xs text-muted-foreground uppercase tracking-[0.2em] font-medium mb-6"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
      >
        Sécurité & Garanties
      </motion.p>
      <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6">
        {badges.map((b, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08 }}
            whileHover={{ scale: 1.05, y: -2 }}
            className="flex items-center gap-3 px-4 py-2.5 rounded-xl bg-card/40 border border-border/30 hover:border-primary/20 transition-all cursor-default group"
          >
            <div className={`w-8 h-8 rounded-lg ${b.bgColor} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
              <b.icon className={`w-4 h-4 ${b.color}`} />
            </div>
            <div className="text-left">
              <span className="text-xs font-semibold text-foreground/90 block leading-tight">{b.label}</span>
              <span className="text-xs text-muted-foreground">{b.sublabel}</span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default SellTrustStrip;
